<template>
 <div :key="reloadKey">
    <loader v-if="loading"/>
    <CRUDCriteria
      :showReset="true"
      :showSearch="false"
      :showAdditionalActions="true"
      :uploadFileParams="uploadFileParams"
    >
      <template v-slot:criteriaRows>
        <v-row dense>
          <v-col cols="2">
            <FySelect id="gl-daily-criteria-FY-select"
              class="glDailyCriteriaFYSelect"
              :fyRange="fiscalYearRange"
              v-model="criteriaState.fiscalYear"
              @input="onChangeFy"
            />
          </v-col>
          <v-col cols="2">
            <v-select
              class="gl-daily-criteria-display-section"
              id="glDailyCriteriaDisplaySection"
              v-model="criteriaState.dailySection"
              :items="glDailySections"
              label="Display Section"
              item-text="description"
              item-value="name"
              @change="searchByCriteria"
            >
            </v-select>
          </v-col>
          <v-col cols="2">
            <ClarionDateControl
              v-model="criteriaState.businessDate"
              :isRequired="false"
              :label="`Business Date`"
              :isIsoDate="true"
              @input="onChangeBusinessDate"
              :rules="businessDateValidation"
              :isToggle="false"
              />
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              class="gl-daily-criteria-fund"
              id="glDailyCriteriaFund"
              v-model="criteriaState.fund"
              :items="funds"
              label="By Fund"
              item-text="fundDesc"
              item-value="_id"
              @change="searchByCriteria"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              class="gl-daily-criteria-bank"
              id="glDailyCriteriaBank"
              v-model="criteriaState.bank"
              label="By Bank"
              :items="banks"
              item-text="bankName"
              item-value="_id"
              @change="searchByCriteria"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </template>
      <template v-slot:additionalActions>
         <v-col cols="5" class="mr-16">
          <v-text-field id="transactionWildCardText"
            class="gl-criteria-wildCard-text"
            label="Wildcard search (Deposit, Transfer in, Transfer out, Payment, or Description)"
            v-uppercase=globalSettingItem.conEverythingToCaps
            v-model="criteriaState.wildcard"
            @input="wildcardSearchDelayed"
            autocomplete="off"
          ></v-text-field>
        </v-col>
         <UploadFile  id="glTransUploadFile"
          class="gltrans uploadFile"
          :bucketName="attachmentConstants.bucketName"
          :program="attachmentConstants.program"
          :parentObjectType="attachmentConstants.parentObjectType"
          :parentObjectId="criteriaState.businessDate"
          :itemIsSaved="isBusinessDate"
          :audit= "false"
        >
        <template v-slot:activator="{ activatorProps }">
        <v-btn
          color="primary"
          class="mr-9 pl-9"
          text
          @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
          @click="imagesLeftClick(activatorProps.leftClick)"
        >
        {{activatorProps.caption}}
        </v-btn>
        </template>
       </UploadFile>
        <v-col cols="2">
          <v-btn color="primary"
            rounded
            dense
            class= "tmc-additional-actions-collect-information"
            :disabled="!disableCollectInfo || loading"
            @click="collectInformation">
            <v-icon class="mr-2">{{ icons.mdiRhombusSplit }}</v-icon>
            Collect<br/>Info
          </v-btn>
      </v-col>
      </template>
    </CRUDCriteria>
    <v-dialog
      v-model="glTransAdditionalDialogBox"
      persistent
      width="50vw"
      height="140vh">
    <v-card>
      <v-card-title></v-card-title>
      <h3 class="headline text-center">
        {{ this.glTransAdditionalDialog.headerTitle }}
      </h3>
      <v-card-title>
        <span class="headline"> {{ this.glTransAdditionalDialog.headerText }}</span>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary"
          text @click="glTransAdditionalDialogAction('ignoreOnce')">
           {{ this.glTransAdditionalDialog.btnOneText }}
        </v-btn>
        <v-btn color="primary"
          text @click="glTransAdditionalDialogAction('ignoreAll')">
          {{ this.glTransAdditionalDialog.btnTwoText }}
        </v-btn>
        <v-btn color="primary"
          text @click="glTransAdditionalDialogAction('Cancel')">
          {{ this.glTransAdditionalDialog.showCancelBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="unpostedPaymentDialogBox"
    persistent
    width="500">
    <v-card>
      <v-card-title class="justify-center">
        <strong>Unposted Payment Found</strong>
      </v-card-title>
      <v-card-text class="text-center">
        Payment {{ unpostedPaymentInfo.paymentNumber }}&nbsp;&nbsp;Receipt {{ unpostedPaymentInfo.receiptNumber }} is unposted.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="unpostedPaymentDialogBox = false">OK</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions,
  mapMutations,
  mapState,
} from 'vuex';
import {
  mdiRhombusSplit,
} from '@mdi/js';
import CRUDCriteria from '../../common/base/crud/CRUDCriteria.vue';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import GLTransactionListMixin from './GLTransactionCommon.mixin';
import {
  calculateFiscalYears, toIsoDate, collectInfoErrorAlert,
} from '../../../util/shared/tmc-global';
import UploadFile from '../../common/UploadFile.vue';
import FySelect from '../../common/FySelect.vue';
import loader from '../../tax/common-utils/loader.vue';
import { checkStringEmptiness, isIsoDate } from '../../../util/shared/vue-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

const fundCrudKey = 'sharedFund';
export default {
  name: 'TransactionCriteria',
  /* :bomb: :firecracker: :boom: Why 'GLTransactionListMixin'
  inside 'TransactionCriteria.vue'? :boom: :bomb: :firecracker: */
  mixins: [GLTransactionListMixin, GlobalToCaps],
  components: {
    CRUDCriteria,
    ClarionDateControl,
    FySelect,
    UploadFile,
    loader,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'transactionCriteria',
    },
  },
  data: () => ({
    reloadKey: 0,
    loadFundsArr: [],
    loading: false,
    preValIndex: 0,
    preValRecord: [],
    activeTransItem: undefined,
    isNew: false,
    icons: {
      mdiRhombusSplit,
    },
    uploadFileParams: {
      bucketName: 'gl',
      program: 'gl',
      parentObjectType: null,
    },
    attachmentConstants: {
      bucketName: 'gl',
      program: 'gl',
      parentObjectType: 'glDailyTransaction',
    },
    glTransAdditionalDialogBox: false,
    glTransAdditionalDialog: {
      headerText: '',
      headerTitle: '',
      btnOneText: 'Ignore Once',
      btnTwoText: 'Ignore All',
      btnThreeText: 'Cancel',
      showCancelBtn: false,
    },
    uploadFileClickParams: {
      leftClickFlag: false,
      leftClickDef: undefined,
      rightClickFlag: false,
      rightClickDef: undefined,
    },
    unpostedPaymentAlertShown: false,
    unpostedPaymentDialogBox: false,
    unpostedPaymentInfo: { paymentNumber: '', receiptNumber: '' },
    collectInfoInFlight: false,
  }),
  created() {
    this.loadFiles();
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'items', 'index']),
    ...mapGetters(['todaysDate']),
    ...mapState({
      fiscalYearRange: (state) => {
        const registerdYears = state.glDaily.glDailyTransaction.regYears || {};
        return calculateFiscalYears(registerdYears, false);
      },
      dailySectionTypes: (state) => state.enums.GlTransDailySectionEnum,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    ...mapState({
      glSettingItem: (state) => state.SystemConfig.glSettingItem || {},
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    businessDateValidation() {
      const yearObj = (this.criteriaState.fiscalYear);
      const businessDate = new Date(this.criteriaState.businessDate);
      const minDate = new Date(`${yearObj - 1}-06-30`);
      const maxDate = new Date(`${yearObj}-06-30`);
      return [
        () => !!((businessDate >= minDate && businessDate <= maxDate)) || 'Date is out of range',
      ];
    },
    funds() {
      const fundObjs = this.items(fundCrudKey) || [];
      const updatedFundObj = fundObjs.map((f) => ({
        ...f,
        fundDesc: f.fund === '0000' ? f.description : `${f.fund} - ${f.description || ''}`,
      }));
      return [{ _id: null, fund: '', fundDesc: '' }, ...updatedFundObj];
    },
    glDailySections() {
      if (!this.dailySectionTypes) {
        return [];
      }
      return [{ name: null, description: 'All' }, ...this.dailySectionTypes];
    },
    disableCollectInfo() {
      if (this.glSettingItem && this.glSettingItem.startDateOnCloud) {
        const startDate = (this.glSettingItem.startDateOnCloud <= this.criteriaState.businessDate);
        if (startDate) {
          const fyDateRange = this.disableCollectInfoBasedOnFY();
          return fyDateRange;
        }
        return startDate;
      }
      return true;
    },
    isBusinessDate() {
      const isBusinessDate = this.criteriaState.businessDate;
      if (isBusinessDate !== null) {
        return true;
      }
      return false;
    },

    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
      'setIndex',
      'setItem',
    ]),
    ...mapMutations('glDaily/glDailyTransaction', [
      'setGLBalance',
    ]),
    ...mapMutations('files', [
      'setFiles',
    ]),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    ...mapActions('glDaily/glDailyTransaction', [
      'loadGLBalance',
      'glCollectInformation',
      'glPreValidateCollectInfo',
    ]),
    ...mapActions('SystemConfig', ['loadConfig',
    ]),
    searchByCriteria() {
      this.handleLoadCRUDList();
    },
    onChangeFy() {
      const {
        fiscalYear, sortBy, skip, limit,
      } = this.criteriaState;
      this.setCriteria([this.baseCrudKey, {
        fiscalYear,
        sortBy,
        skip,
        limit,
        dailySection: null,
        businessDate: '',
        fund: null,
        bank: null,
        wildcard: undefined,
      }]);
      this.reloadKey += 1;
      this.searchByCriteria();
      this.loadGLBalanceByCriteria();
      this.loadFundList();
    },
    onChangeBusinessDate() {
      if (isIsoDate(this.criteriaState.businessDate)) {
        clearTimeout(this.delayTimerId);
        // delay new call
        this.delayTimerId = setTimeout(async () => {
          this.searchByCriteria();
          this.loadGLBalanceByCriteria();
          this.loadFiles();
        }, 250);
      }
    },
    async loadGLBalanceByCriteria() {
      if (this.criteriaState.fiscalYear != null
      && !checkStringEmptiness(this.criteriaState.businessDate)) {
        this.loadGLBalance({
          criteria: {
            fiscalYear: this.criteriaState.fiscalYear,
            businessDate: toIsoDate(this.criteriaState.businessDate),
            skipApprortionment: true,
          },
        });
      }
    },
    handleLoadCRUDList(criteriaArgs = {}) {
      this.$emit('loadCRUDList', criteriaArgs);
    },
    loadFundList() {
      this.loadFunds({
        criteria: {
          fiscalYear: this.criteriaState.fiscalYear,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: fundCrudKey,
      });
    },
    disableCollectInfoBasedOnFY() {
      const { businessDate } = this.criteriaState;
      const minDate = `${this.criteriaState.fiscalYear - 1}-07-01`;
      const maxDate = `${this.criteriaState.fiscalYear}-06-30`;
      if ((businessDate >= minDate) && (businessDate <= maxDate)) {
        return true;
      }
      return false;
    },
    glTransDailogBox(text) {
      this.glTransAdditionalDialogBox = true;
      this.glTransAdditionalDialog.headerTitle = 'Unposted Payment Found';
      this.glTransAdditionalDialog.headerText = text;
      this.glTransAdditionalDialog.btnOneText = 'Ignore Once';
      this.glTransAdditionalDialog.btnTwoText = 'Ignore All';
      this.glTransAdditionalDialog.showCancelBtn = 'Cancel';
    },
    async glTransAdditionalDialogAction(isResponseFlag) {
      this.glTransAdditionalDialogBox = false;
      this.glTransAdditionalDialog.headerText = '';
      this.glTransAdditionalDialog.headerTitle = '';
      this.glTransAdditionalDialog.showCancelBtn = '';
      const record = this.preValRecord;
      const criteria = {
        fiscalYear: this.criteriaState.fiscalYear,
        businessDate: this.criteriaState.businessDate,
      };
      this.preValIndex += 1;
      const prevRecord = (record[this.preValIndex - 1] || {}).error;
      const currRecord = (record[this.preValIndex] || {}).error;
      if (isResponseFlag === 'ignoreOnce' || (this.preValIndex < record.length)) {
        this.glTransDailogBox(currRecord);
      }
      if (isResponseFlag === 'Cancel') {
        this.glTransDailogBox(prevRecord);
        setTimeout(() => {
          this.glTransAdditionalDialogBox = false;
        }, 500);
        this.preValIndex = 0;
      }
      if (isResponseFlag === 'ignoreAll' || (this.preValIndex === record.length)) {
        this.glTransDailogBox(prevRecord);
        setTimeout(async () => {
          this.glTransAdditionalDialogBox = false;
          await this.collectInfoAfterPreValidate(criteria);
          this.preValIndex = 0;
        }, 200);
      }
    },
    async collectInformation() {
      /* Cheap early bail so a fast double-click doesn't also fire a redundant
      glPreValidateCollectInfo call / re-open the tax-payment dialog while a real
      collect is in flight. collectInfoAfterPreValidate below remains the
      authoritative guard around the actual glCollectInformation call. */
      if (this.collectInfoInFlight) {
        return;
      }
      this.unpostedPaymentAlertShown = false;
      const criteria = {
        fiscalYear: this.criteriaState.fiscalYear,
        businessDate: this.criteriaState.businessDate,
      };
      try {
        this.loading = true;
        const glConfig = await this.loadConfig({ requiredScope: 'glConfig' });
        const { cloudTaxSystem } = (glConfig[0].configuration || {});
        const preValResult = await this.glPreValidateCollectInfo({ criteria });
        this.preValIndex = -1;
        // if result opendailog box
        if (preValResult.taxPaymentRecord.length > 0 && cloudTaxSystem) {
          this.preValRecord = preValResult.taxPaymentRecord;
          this.glTransAdditionalDialogAction('ignoreOnce');
        } else {
          await this.collectInfoAfterPreValidate(criteria);
        }
      } finally {
        this.loading = false;
      }
    },
    async collectInfoAfterPreValidate(criteria) {
      /* Two overlapping collects duplicate the day's tagged total records, and the
      pre-validate dialog can fire this more than once, so only allow one at a time. */
      if (this.collectInfoInFlight) {
        return;
      }
      this.collectInfoInFlight = true;
      try {
        this.loading = true;
        const result = await this.glCollectInformation({ criteria });
        console.info('getdata', result);
        if (result && result.alreadyRunning) {
          alert(
            'Collect Info is already running for this business date. Please wait for it to finish before collecting again.',
          );
          return;
        }
        if (result && result.unpostedPayment && !this.unpostedPaymentAlertShown) {
          this.unpostedPaymentAlertShown = true;
          this.unpostedPaymentInfo = result.unpostedPayment;
          this.unpostedPaymentDialogBox = true;
        }
        const isLocked = ((result || {}).locked || false);
        if (isLocked) {
          alert(
            "There are locked records on this date. No locked records will be updated. if you wish to update these records, please unlock records and then 'Collect Info' again",
          );
        }
        const errorAlert = collectInfoErrorAlert(result);
        if (errorAlert) {
          alert(errorAlert);
        }
        this.searchByCriteria();
        this.loadGLBalanceByCriteria();
      } finally {
        this.loading = false;
        this.collectInfoInFlight = false;
      }
    },
    async imagesLeftClick(leftClick) {
      if (this.isNew) {
        this.uploadFileClickParams.leftClickFlag = true;
        this.uploadFileClickParams.leftClickDef = leftClick;
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNew) {
        this.uploadFileClickParams.rightClickFlag = true;
        this.uploadFileClickParams.rightClickDef = rightClick;
      } else {
        rightClick();
      }
    },
    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: this.criteriaState.businessDate,
      });
    },
    wildcardSearchDelayed() {
      // cancel pending call
      clearTimeout(this.delayTimerId);
      // delay new call
      this.delayTimerId = setTimeout(async () => {
        const criteriaArgs = { searchMode: 'wildcard' };
        await this.handleLoadCRUDList(criteriaArgs);
        this.criteriaState.businessDate = '';
      }, 250);
    },
  },
};
</script>
